<template>
  <div>
    <div class="teacher-class-container white rounded-5 w-100 h-auto">
      <!-- CLASS CARD COMPONENT -->
      <template v-if="children.length > 0">
        <ChildCard
          :child_id="data.id"
          :child_img="data.image"
          :child_name="data.full_name"
          :child_code="data.class_code"
          :child_class_id="data.class_id"
          :active="data.active"
          v-for="(data, index) in children"
          :key="index"
          @child-selected="childActive"
        ></ChildCard>
      </template>
      <ChildDefaultCard
        v-else
        :is_empty="is_empty"
        :is_loading="is_loading"
      ></ChildDefaultCard>
      <!-- CLASS CARD COMPONENT -->

      <!-- ADD CLASS OPTION -->
      <div class="add-more-class w-100">
        <div class="add-new-item pointer w-100 my-1" @click="goToAddChild">
          <div class="undone"></div>
          <div class="label-text color_text">Add a Child</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ChildCard from "@/components/classComps/parentSideBar/ChildCard";
import ChildDefaultCard from "@/components/classComps/parentSideBar/ChildDefaultCard";

export default {
  name: "ParentChildCard",

  components: {
    ChildCard,
    ChildDefaultCard,
  },

  computed: {
    ...mapGetters(["getSelectedChildID"]),
  },

  data() {
    return {
      children: [],
      active_index: "",
      is_empty: false,
      is_loading: true,
      child_id: 0,
    };
  },

  mounted() {
    this.loadChildren();
  },

  watch: {
    $route: {
      handler() {
        this.getSchoolClassDetails();
      },
      immediate: true,
    },
  },

  methods: {
    ...mapActions([
      "getParentChildren",
      "setSelectedChildID",
      "setCurrentClass",
      "getChildClassDetails",
      "updateSummerMode",
    ]),

    getSchoolClassDetails() {
      this.getChildClassDetails(this.$route.params.id)
        .then((response) => {
          // UPDATE SUMMER STATUS
          if (response.data.in_summer_school === 1)
            this.updateSummerMode({
              student_id: this.$route.params.id,
              summer_school: 1,
            });
          else
            this.updateSummerMode({
              student_id: this.$route.params.id,
              summer_school: 0,
            });
        })
        .catch((err) => console.log(err));
    },

    goToAddChild() {
      this.$router.push("/parent/onboarding/new-child");
    },

    childActive($event) {
      this.children.map((child) => (child.active = false));
      this.children.map((child, index) => {
        if (child.id === $event.child_id) {
          this.children[index].active = true;
        }
      });
      this.setSelectedChildID($event.child_id);
      this.setCurrentClass($event.class_id);
      this.$router.push({
        name: this.$router.currentRoute.name,
        params: { id: $event.child_id },
      });
    },

    loadChildren() {
      this.getParentChildren()
        .then((response) => {
          if (response.code === 200) {
            let { data } = response;
            this.children = [];

            // UPDATE STUDENT RELATIONSHIP
            this.$store.commit("UPDATE_RELATIONSHIP_STATUS", data.length);

            data.map((child) => {
              let child_obj = {};
              child_obj.id = Number(child.id);
              child_obj.image = child.image;
              child_obj.full_name = child.full_name;
              child_obj.class_code = child.code;
              child_obj.class_id = child.class ? child.class.id : null;

              // if (child.class) child_obj.class_id = child.class.id;
              // else child_obj.class_id = 0;

              child_obj.active = false;

              this.children.push(child_obj);
            });
            this.setActiveClass();
          } else {
            this.is_empty = true;
            this.is_loading = false;
          }
        })
        .catch((err) => console.log(err));
    },

    setActiveClass() {
      if (this.getSelectedChildID) {
        if (this.getSelectedChildID === this.$route.params.id)
          this.child_id = this.getSelectedChildID;
        else if (this.$route.params.id == 0) {
          this.child_id = this.getSelectedChildID;

          this.$router.replace({
            name: this.$router.currentRoute.name,
            params: { id: this.getSelectedChildID },
          });
        } else this.child_id = this.$route.params.id;

        this.children.map((child, index) => {
          if (child.id == this.child_id) {
            this.children[index].active = true;
            this.setSelectedChildID(this.children[index].id);
            this.setCurrentClass(this.children[index].class_id);
          }
        });
      } else {
        this.children[0].active = true;
        this.setSelectedChildID(this.children[0].id);
        this.setCurrentClass(this.children[0].class_id);
        this.$router.replace({
          name: this.$router.currentRoute.name,
          params: { id: this.children[0].id },
          query: this.$route.query.summer ? { summer: true } : null,
        });
      }
    },
  },
};
</script>

<style lang="scss">
.teacher-class-container {
  @include breakpoint_max(lg) {
    width: 115% !important;
  }

  @include breakpoint_max(md) {
    width: 100% !important;
    margin-bottom: 20px;
  }
  .add-more-class {
    border-top: 1px solid $border_grey;
    padding: 15px 16px;
    font-size: 14px;
    line-height: 19px;
  }
}
</style>
